var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2284_3545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 23.5H5C2.8 23.5 1 21.7 1 19.5V8.5C1 6.3 2.8 4.5 5 4.5H19C21.2 4.5 23 6.3 23 8.5V19.5C23 21.7 21.2 23.5 19 23.5Z",
    stroke: "#",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5V7.3",
    stroke: "#",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5V7.3",
    stroke: "#",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5H6C5.4 15.5 5 15.9 5 16.5V18.5C5 19.1 5.4 19.5 6 19.5H8C8.6 19.5 9 19.1 9 18.5V16.5C9 15.9 8.6 15.5 8 15.5Z",
    stroke: "#",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2284_3545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3.8147e-06 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPlp);
export default __webpack_public_path__ + "static/media/CalendarPlp.43169fe61fdf863ab19dc2e3680b8ede.svg";
export { ForwardRef as ReactComponent };